
import React, { useEffect, useState } from 'react'
import { Dropdown, Grid, Icon, Rail } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash'
import { useTranslation } from 'react-i18next';

import { SetPropertyListing } from "../../../../redux/actions/mainActions"
import "./SearchPropertyListing.css"

const SearchPropertyListing = ({ activeItem, setActiveItem }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const source = [
    { text: 'اجاره', value: 'ویلا' },
    { text: 'فروش', value: 'فروش' },
    { text: 'رهن', value: 'رهن' },
    { text: 'همه موراد', value: 'همه موراد' },
  ]



  const propertyListing = useSelector((state) => state.main.propertyListing)




  const handleSearchChange = (e, { value }) => {
    dispatch(SetPropertyListing(value))
    setActiveItem("")

  }



  return <Grid centered verticalAlign="middle" >


    <Grid.Column width={16}>

      <Dropdown
        open={activeItem == "property-listing"}
        icon="none"
        placeholder={t("home:ChooseAnOption")}
        fluid
        search
        selection
        //clearable
        options={source}
        className="search-property-listing"
        onChange={(e, data) => handleSearchChange(e, data)}
        onFocus={()=>setActiveItem( "property-listing")}

        value={propertyListing}
      />

    </Grid.Column>
  </Grid>
}
export default SearchPropertyListing